<template>

  <v-card-text>

    <v-select solo dense read-only v-model="scenarioTxt" :items="scenariosTxt" :label="$t('scenario')"
    color="onprimary" item-color="onprimary"></v-select>
    <div class="pegelsliderDivGrundwasser">
      <div class="pegelslider">
        <v-slider color="onprimary" track-color="onprimary" v-model="scenarioIdx" vertical :max="1" ticks="always"
          step="1" tick-size="6">
        </v-slider>
      </div>
      <div>
        <v-img class="pegellatte" src="static/images/pegelslider150blau.png"></v-img>
      </div>
      <!--
      <div class="sliderScenarioLabel">
        <table height="100%">
          <tr><td>{{ $t('topic.Grundwasser.slider1') }}</td></tr>
          <tr><td>{{ $t('topic.Grundwasser.slider0') }}</td></tr>
        </table>
      </div>
      -->
    </div>

    <!-- TODO Opacitiy Slider anbieten? -->
    <wgu-layeropacitycontrolcustom
        :layer="activeLayer"
         v-if="activeLayer"
      />
    <v-list-item v-if="showLegends && activeLayer">
      <wgu-layerlegendimagecustom :layer="activeLayer" :mapView="mapView" />
    </v-list-item>
  </v-card-text>
</template>

<script scoped>
import { Mapable } from '../../../src/mixins/Mapable';
import LayerLegendImageCustom from './LayerLegendImageCustom.vue'
import LayerOpacityControlCustom from './LayerOpacityControlCustom.vue';
// import LayerListItem from './LayerListItem'

export default {
  name: 'wgu-layerlistgrundwasser',
  components: {
    'wgu-layerlegendimagecustom': LayerLegendImageCustom,
    'wgu-layeropacitycontrolcustom': LayerOpacityControlCustom
  },
  mixins: [Mapable],
  props: {
    showLegends: { type: Boolean, required: true },
    showOpacityControls: { type: Boolean, required: true },
    layersTopicName: { type: String, required: true }
  },
  data () {
    return {
      mapView: null,
      layers: [],
      activeLayer: null,
      scenarios: ['gw100', 'gw200'], /* TODO: Szenarien aus Visible Layer? An welcher Stelle? *onMapBound? */
      scenariosTxt: [
        this.$t('topic.Grundwasser.slider0'),
        this.$t('topic.Grundwasser.slider1')
      ],
      scenarioTxt: this.$t('topic.Grundwasser.slider0'), /* TODO: Startszenarion aus Visible Layer? An welcher Stelle? *onMapBound? */
      scenarioIdx: 0 /* TODO: Startszenarion aus Visible Layer? An welcher Stelle? *onMapBound? */
    }
  },
  methods: {
    /**
       * This function is executed, after the map is bound (see mixins/Mapable).
       * Bind to the layers from the OpenLayers map.
       */
    onMapBound () {
      this.mapView = this.map.getView();
      this.layers = this.map.getLayers().getArray();
      this.getActiveLayer();
    },
    adjustLayerVisibility (makeThisLayerVisible) {
      this.displayedLayers.forEach(l => {
        if (l.get('lid') !== makeThisLayerVisible && l.get('lid') !== 'hw_schutz_fcl') {
          l.setVisible(false)
        } else {
          l.setVisible(true)
          this.activeLayer = l
        }
      }

      )
    },
    getActiveLayer () {
      this.displayedLayers.forEach(l => {
        if (l.getVisible() && l.get('lid') !== 'hw_schutz_fcl') {
          this.activeLayer = l;
        }
      }
      )
    },
    setSliderValue (idx) {
      this.scenario = idx
    }
  },
  computed: {
    /**
       * Reactive property to return the OpenLayers layers to be shown in the control.
       * Remarks: The 'displayInLayerList' attribute should default to true per convention.
       */
    displayedLayers () {
      return this.layers
        .filter(layer => layer.get('displayInLayerList') !== false && !layer.get('isBaseLayer') && layer.get('layerGroup') === this.layersTopicName)
        .reverse();
    }
  },
  watch: {
    scenarioTxt: function (s1, s2) {
      // Kopplung Slider und Select
      this.scenarioIdx = this.scenariosTxt.indexOf(s1)
    },
    scenarioIdx: function (s1, s2) {
      // Kopplung Slider und Select
      this.scenarioTxt = this.scenariosTxt[s1]

      // Aktivierung Layer
      this.adjustLayerVisibility(this.scenarios[s1])
    }
  }
}
</script>

<style scoped>
   .v-list-item {
    padding-left: 4px !important;
  }
</style>

  <style>

  .pegelsliderDivGrundwasser {
    display: flex;
    /* TODO height media abhängig */
  }

  .pegelsliderDivGrundwasser .pegelslider {
    margin-top: 35px;
    margin-bottom: 18px;
    margin-left: 8px;
    margin-right: 8px;
  }

  .pegellatte {
    height: 150px;
  }

  /* sieht gut aus ! */
  .pegelsliderDivGrundwasser .v-slider--vertical {
    min-height: 55px !important;
  }

  .pegelsliderDivGrundwasser .v-slider__tick {
    background-color: #7FB0D0;
  }

  /*
  :deep(.v-slider.v-input--vertical > .v-input__control) {
      min-height: 100px !important;
    }
*/
</style>
